import {
  CameraOutlined as camera,
  ArrowRightOutlined as arrowRight,
  MenuOutlined as menuLine,
  SearchOutlined as searchIcon,
  ShoppingCartOutlined as shoppingIcon,
  BellOutlined as bellIcon,
  MailOutlined as mailIcon,
  UploadOutlined as uploadFileIcon,
  ExclamationCircleOutlined as exclameIcon,
  DownloadOutlined as download,
  MinusOutlined as sub,
  InfoCircleOutlined as inforCircle,
  DownOutlined as downOutline,
  StarTwoTone as starTwoTone,
  FilterTwoTone as filterTwoTone,
  CopyTwoTone as copyTwoTone,
} from "@ant-design/icons";

export default {
  arrowRight,
  camera,
  menuLine,
  searchIcon,
  shoppingIcon,
  bellIcon,
  mailIcon,
  uploadFileIcon,
  exclameIcon,
  download,
  sub,
  inforCircle,
  downOutline,
  starTwoTone,
  filterTwoTone,
  copyTwoTone,
};
